/* eslint-disable no-use-before-define,eqeqeq */

export const formatXAxisTicks = (value, filterByDate, hasData) => {
    if (!value) return ''
    const d = new Date(value)
    if (isNaN(d.getTime())) return value
    if (filterByDate == 0 && hasData) {
        const h = d.getHours()
        const m = d.getMinutes()
        const ampm = h >= 12 ? 'PM' : 'AM'
        const h12 = h % 12 || 12
        return `${String(h12).padStart(2, '0')}:${String(m).padStart(2, '0')} ${ampm}`
    }
    return `${String(d.getMonth() + 1).padStart(2, '0')}/${String(d.getDate()).padStart(2, '0')}`
}

export const formatYAxisTicks = (value, showDataAs) => {
    const formatted = value.toLocaleString("en-US", {minimumFractionDigits:1, maximumFractionDigits:1})
    return showDataAs === 'price-history' 
        ? formatted 
        : `${formatted}%`
}